import type { ComponentType } from 'react'
import { CityIcon } from '@/shared/ui/icons/CityIcon'
import { HomeIcon } from '@/shared/ui/icons/HomeIcon'
import { LocationPinIcon } from '@/shared/ui/icons/LocationPinIcon'
import { MegaphoneIcon } from '@/shared/ui/icons/MegaphoneIcon'
import { MessageIcon } from '@/shared/ui/icons/MessageIcon'

/**
 * 주요 메뉴의 **정본**. 화면(PC 헤더 · 모바일 사이드바)은 이 목록을 읽어 그리고,
 * 자기 목록을 따로 갖지 않는다 — 두 곳에 같은 목록이 있으면 한쪽만 고쳐지는 일이 실제로 났다
 * (소식 메뉴를 빼면서 세 파일을 각각 고쳐야 했다).
 */
export type NavItem = {
  to: string
  label: string
  /** `NavLink` 의 `end` — 홈만 주소가 정확히 일치할 때 활성이다. */
  end: boolean
  icon: ComponentType<{ size?: number }>
  /** 사이드바에서 오른쪽 화살표를 붙이는지. 헤더는 쓰지 않는다. */
  chevron: boolean
}

export const MAIN_NAV: NavItem[] = [
  { to: '/', label: '홈', end: true, icon: HomeIcon, chevron: false },
  { to: '/problems', label: '시민 문제', end: false, icon: MessageIcon, chevron: true },
  { to: '/solutions', label: '기업 해결 카드', end: false, icon: CityIcon, chevron: true },
  { to: '/map', label: '해봄 지도', end: false, icon: LocationPinIcon, chevron: true },
  { to: '/board', label: '소식', end: false, icon: MegaphoneIcon, chevron: true },
]
